import { TIMELINE_STEPS, TrancheBotV2Status } from "./constant";


const statusToStepMap = new Map();
TIMELINE_STEPS.forEach((stepInfo) => {
  stepInfo.statuses.forEach((status) => {
    statusToStepMap.set(status, stepInfo.step);
  });
});


export const processTimelineData = (trancheLogs = []) => {
  const stepLogMap = new Map();

  trancheLogs.forEach((log) => {
    const step = statusToStepMap.get(log.status);
    if (step) {
      stepLogMap.set(step, log);
    }
  });

  const completedStepNumbers = Array.from(stepLogMap.keys());
  const highestCompletedStep =
    completedStepNumbers.length > 0 ? Math.max(...completedStepNumbers) : 0;

  // Find last log (chronologically latest)
  const lastLog =
    trancheLogs.length > 0 ? trancheLogs[trancheLogs.length - 1] : null;

  // Check if the last status is SUCCESS or REJECTED
  const isFinalStatus =
    lastLog &&
    [
      TrancheBotV2Status.SUCCESS,
      TrancheBotV2Status.REJECTED,
      TrancheBotV2Status.ZOHO_FAILED,
    ].includes(lastLog.status);

  return TIMELINE_STEPS.map((stepInfo) => {
    const stepLog = stepLogMap.get(stepInfo.step) || null;
    const isCompleted =
      isFinalStatus && stepInfo.step === 4
        ? true
        : stepInfo.step <= highestCompletedStep;

    const isActive =
      isFinalStatus && stepInfo.step === 4
        ? true
        : stepInfo.step === highestCompletedStep;

    return {
      ...stepInfo,
      isCompleted,
      isActive,
      log: stepLog,
    };
  });
};

